import React from 'react';
import { Typography, withStyles } from '@material-ui/core';
import ThemeVars from '../ThemeVars';
import { useTranslation } from 'react-i18next';

const styles = theme => ({
    footer: {
        height: '50px',
        color: ThemeVars.footerColor,
        backgroundColor: ThemeVars.footerBackground,
        paddingLeft: theme.spacing.unit * 3
    }
});

const Footer = ({ visible, classes }) => {
    const { t } = useTranslation();
    if (visible !== false) {
        return (
            <footer className={classes.footer}>
                <Typography color="inherit">{t('Footer teksti')}</Typography>
            </footer>
        );
    }
};

export default withStyles(styles)(Footer);



// WEBPACK FOOTER //
// ./resources/assets/js/components/Footer.js